import { ICrosshairConfig } from "../interfaces/interface";

export interface IFavoriteResult {
    isFavorited: boolean;
    favoriteCount: number;
}

export const favoritesService = {
    list: async (): Promise<ICrosshairConfig[]> => {
        const response = await fetch("/api/favorites", { credentials: "include" });
        if (response.status === 401) throw new Error("UNAUTHORIZED");
        if (!response.ok) throw new Error(`Failed to list favorites: ${response.status}`);
        const rows = await response.json();
        return (rows as Record<string, unknown>[]).map((row) => ({
            id: row.id as number,
            name: row.name as string,
            slug: (row.slug as string) ?? String(row.id),
            code: row.code as string,
            isPro: Boolean(row.isPro),
            isFun: Boolean(row.isFun),
            favoriteCount: row.favoriteCount as number,
            isFavorited: Boolean(row.isFavorited),
            submissionStatus: (row.submissionStatus as string) ?? null,
        }));
    },
    toggle: async (crosshairId: number): Promise<IFavoriteResult> => {
        const response = await fetch(`/api/favorites/${crosshairId}`, {
            method: 'POST',
            credentials: 'include',
        });
        if (response.status === 401) throw new Error('UNAUTHORIZED');
        if (!response.ok) throw new Error(`Failed to toggle favorite: ${response.status}`);
        return response.json();
    },
};
